/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 17:21:10
 * @LastEditTime: 2021-05-25 19:17:43
 * @LastEditors: wangshengqiang
 * @Description: 告知牛逼
 */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import Render from '@/components/Render';
import './FixedBottom.less';
const FixedBottom = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children
  } = props;
  const {
    noticeObjectType = 'insured'
  } = attrs || {};
  const cls = classnames({
    'components-fixed-bottom-render': true // [className]: !!className,

  }); // const children = useMemo(() => {
  //   children.forEach((child = {}, index) => {
  //     child.attrs = child.attrs || {};
  //     child.attrs.noticeObjectType=noticeObjectType;
  //     child.attrs.healthSpecialConfig = {
  //       type: 'healthInfo',
  //       index,
  //     };
  //   });
  //   return children;
  // }, [children]);

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
export default FixedBottom;